import React, { Component } from "react";
import { css, StyleSheet } from "aphrodite/no-important";

import tick from "../../images/tick-icon.svg";

class coloumnTickBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      href: props.href ? props.href : ""
    };
  }

  createBlocks(info) {
    return info.map((text, i) => {
      return (
        <div
          key={i}
          style={{
            width: "100%",
            textAlign: "left",
            marginBottom: "18px",
            position: "relative"
          }}
        >
          <div style={{ height: "100%", float: "left", marginTop: "4px" }}>
            <img className={`${css(styles.tick)}`} width="20" src={tick} />
          </div>
          <div style={{ height: "100%" }}>{text}</div>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="text-center">
        <div className={`row benefits`}>
          {this.createBlocks(this.props.data)}
        </div>
      </div>
    );
  }
}

export default coloumnTickBox;

const styles = StyleSheet.create({
  p: {
    marginBottom: "0px"
  },
  tick: {
    marginRight: "10px",
    marginTop: "-3px"
  }
});



// WEBPACK FOOTER //
// ./src/sections/layouts/verticalTickBox.js